<template>
    <v-app id="app">
        <!-- APP: LEFT NAVIGATION DRAWER -->
        <NavigationDrawer
                v-if="$route.meta.showNavigationDrawer"
                :right="false"
        ></NavigationDrawer>

        <!-- APP: TOP TOOLBAR -->
        <AppToolbar
                v-if="$route.meta.showAppToolbar"
                :title="$route.meta.toolbarTitle"
        ></AppToolbar>

        <AppToolbarInnovationPublic
                v-if="$route.meta.showAppToolbarInnovation"
        ></AppToolbarInnovationPublic>

        <AppToolbarGhost
                v-if="$route.meta.showAppToolbarGhost"
        ></AppToolbarGhost>

        <AppToolbarGhostLogout
                v-if="$route.meta.showAppToolbarGhostLogout"
        ></AppToolbarGhostLogout>

        <!-- APP: CONTENT -->
        <AppContent></AppContent>

        <!-- APP: FOOTER -->
        <AppFooter v-if="$route.meta.showAppFooter"></AppFooter>

        <!-- GLOBAL CONTROLS -->
        <GlobalToast :state="globalToastState"/>
        <GlobalLoader :state="globalLoaderState"/>
        <GlobalNotificationsPanel
                v-show="isGlobalNotificationsPanel"
                :state="globalNotifications"
        />
        <GlobalNotificationsFloating
                v-show="!isGlobalNotificationsPanel"
                :state="globalNotifications"
        />
        <GlobalFilePanel v-show="Object.keys(fileInLoading).length > 0"/>
    </v-app>
</template>

<script>
    import {mapGetters, mapState,} from "vuex";

    import NavigationDrawer from "@/pages/Layout/NavigationDrawer";
    import AppContent from "@/pages/Layout/AppContent";
    import AppToolbar from "@/pages/Layout/AppToolbar";
    import AppToolbarInnovationPublic from "@/pages/Layout/AppToolbarInnovationPublic";
    import AppFooter from "@/pages/Layout/AppFooter";
    import GlobalToast from "@/components/GlobalControls/GlobalToast";
    import GlobalLoader from "@/components/GlobalControls/GlobalLoader";
    import GlobalNotificationsFloating from "@/components/GlobalControls/Notifications/GlobalNotificationsFloating";
    import GlobalNotificationsPanel from "@/components/GlobalControls/Notifications/GlobalNotificationsPanel";
    import GlobalFilePanel from "@/components/GlobalControls/GlobalFilePanel";

    import SettingsService from "@/helpers/SettingsService";
    import StateService from "@/helpers/StateService";
    import NotificationService from "@/helpers/NotificationService";
    import AppToolbarGhost from "@/pages/Layout/AppToolbarGhost";
    import AppToolbarGhostLogout from "@/pages/Layout/AppToolbarGhostLogout";



    export default {
        name: "AppStructure",
        components: {
            NavigationDrawer,
            AppToolbar,
            AppToolbarInnovationPublic,
            AppToolbarGhost,
            AppToolbarGhostLogout,
            AppContent,
            AppFooter,
            GlobalToast,
            GlobalLoader,
            GlobalNotificationsFloating,
            GlobalNotificationsPanel,
            GlobalFilePanel,
        },

        mixins: [],
        props: {},
        data() {
            return {};
        },
        computed: {
            ...mapState({}),
            ...mapGetters("AppState", {
                hasSplashed: "hasSplashed",
                isLeftNavDrawer: "isLeftNavDrawer",
                isLeftTempNavDrawer: "isLeftTempNavDrawer",
                isGlobalNotificationsPanel: "isGlobalNotificationsPanel",
                globalToastState: "getGlobalToastState",
                globalLoaderState: "getGlobalLoaderState",
            }),
            ...mapGetters("UserState", {
                globalNotifications: "getGlobalNotifications",
                globalNotificationsNotDismissed: "getGlobalNotificationsNotDismissed",
            }),
            ...mapGetters("FileInputState", {
                fileInLoading: "getFileInLoading",
            }),

        },
        created() {
            NotificationService.reset();
            StateService.resetAllVolatileData();
            SettingsService.save();
        },
        methods: {
            closePanel: function (event) {
                if (event.target.id !== "notificationButton" && event.target.id !== "notificationBadge" &&
                    event.target.id !== "notificationLength" && event.target.id !== "notificationHeader" &&
                    event.target.id !== "notificationIcon") {
                    this.$store.dispatch("AppState/setGlobalNotificationsPanel", false);
                }
            },
        },
    };
</script>

<style lang="scss">
    @import "../../assets/styles/scss/chatbot/commons"; // TODO - reorganize

    #app {
        font-family: $font-book;
    }
</style>

